import { FC, ReactNode, CSSProperties } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
}

const useStyles = makeStyles(
  () => ({
    root: {
      padding: '12px',
    },
  }),
  { name: 'WbCardContent' },
);

export const WbCardContentStub: FC<Props> = ({ children, style, className }) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      {children}
    </Box>
  );
};
